import { FetchStatus } from '../core';
import { RootState } from '../index';
import { SpaceTab } from './schema';

export const getIsCreating = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.creating;

export const getIsEmbedding = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.embedding;

export const getSpaceTabsBySpaceId =
  (spaceId: number) =>
  ({ spaces, spaceTabs }: RootState): SpaceTab[] => {
    const tabs =
      spaces.items[spaceId].spaceTabOrder?.map((id) => spaceTabs.items[id]) ||
      [];

    const spaceTabIds = tabs.map((s) => s.spaceTabId);

    // This is done for the case when spaceTabIds are missing from the spaceTabOrder array
    // Exclude the space tabs whose ids are present in the spaceTabOrder array and follow the order of the spaces parameter
    const tabsNotPartofSpaceTabOrder = Object.values(spaceTabs.items).filter(
      (s) => Number(s.space) === spaceId && !spaceTabIds.includes(s.spaceTabId),
    );

    const allSpaceTabs = tabs.concat(tabsNotPartofSpaceTabOrder);

    return allSpaceTabs;
  };

export const getSpaceTabByIdSelector =
  (spaceTabId: number) =>
  ({ spaceTabs }: RootState): SpaceTab =>
    spaceTabs.items[spaceTabId];

export const getActiveTabKey = ({ spaceTabs }: RootState): string =>
  spaceTabs.activeTabKey;

export const isSpaceTabUpdatingSelector = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.updating;

export const isSpaceTabDeletingSelector = ({ spaceTabs }: RootState): boolean =>
  spaceTabs.deleting;

export const selectSpaceTab =
  (spaceTabId: number) =>
  ({ spaceTabs }: RootState): SpaceTab =>
    spaceTabs.items[spaceTabId];

export const selectSpaceTabFetchStatus =
  (spaceTabId: number) =>
  ({ spaceTabs }: RootState): FetchStatus =>
    spaceTabs.itemsFetchStatus[spaceTabId];
